import { imgSrc, imgSet } from '@images/error403';
import React from 'react';

export default {
    imgSrc,
    imgSet: `${imgSet[0]} 2x, ${imgSet[1]} 3x`,
    code: '403',
    title: 'Доступ запрещен',
    getContent() {
        return (
            <div>
                <p>Поздравляем, вы нашли тайную дверь.</p>
                <p>Но дальше вы пройти не сможете. Попробуйте начать заново.</p>
            </div>
        );
    },
};
